module.exports = __webpack_public_path__ + "static/nyoutritious-3-4c33a369efe70e56435b787a5abc0cd6.png";